export default __webpack_public_path__ + "static/media/Armguards of the Chaos Agent.ce183df2.jpg";